const tabs = document.querySelectorAll('.procedures-tab a.tab');

if(tabs) {
    tabs.forEach( (item) => {
        item.addEventListener('click', (e)=> {
            e.preventDefault();
            
            tabs.forEach( (tabLink) => {
                tabLink.classList.remove('active');
            });

            // clicked tab link
            item.classList.add('active');
            
            // tab content
            let target = item.getAttribute('data-toggle-target');
            let tabsContent = document.querySelectorAll('.tab-content');
            
            tabsContent.forEach((tab) => {
                tab.classList.remove('active');
            });
            
            document.querySelector(target).classList.add('active');
        })
    });
}